module.exports = __webpack_public_path__ + "static/4i-de8f0fad9511acf7b9f69d6ce453e946.woff2";